import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dashboard-area company-dashboard pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-lg-12",
  id: "scrollTarget"
}
const _hoisted_5 = { class: "table-wrapper2" }
const _hoisted_6 = { class: "title-and-btn" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Latest Job List:")
], -1)
const _hoisted_8 = { class: "job-post-btn" }
const _hoisted_9 = { class: "table-filter-area mb-30" }
const _hoisted_10 = { class: "form-wrap style-2 style-3" }
const _hoisted_11 = { class: "form-inner" }
const _hoisted_12 = { class: "input-area" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/search-2.svg",
  alt: ""
}, null, -1)
const _hoisted_14 = { class: "form-wrap style-3" }
const _hoisted_15 = { class: "form-inner" }
const _hoisted_16 = { class: "input-area" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/calender2.svg",
  alt: ""
}, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "alert alert-warning mt-3",
  role: "alert"
}
const _hoisted_19 = { class: "eg-table table job-list-table mb-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Advertisement Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Job Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Applications on job"),
    /*#__PURE__*/_createElementVNode("th", null, "Ad Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { colspan: "6" }
const _hoisted_23 = { "data-label": "Ad Title" }
const _hoisted_24 = { class: "job-content" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/calender2.svg",
  alt: ""
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Expiration:", -1)
const _hoisted_27 = { "data-label": "Job Title" }
const _hoisted_28 = { class: "job-content" }
const _hoisted_29 = { class: "ms-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/calender2.svg",
  alt: ""
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Job Expiration:", -1)
const _hoisted_32 = { "data-label": "Total Application" }
const _hoisted_33 = { class: "total-number light-#00ffef" }
const _hoisted_34 = { "data-label": "Viewed" }
const _hoisted_35 = { "data-label": "Action" }
const _hoisted_36 = { class: "action-btn-group2 nav nav-bar" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14 5C14 5 11.375 0 7 0C2.625 0 0 5 0 5C0 5 2.625 10 7 10C11.375 10 14 5 14 5ZM1.02637 5C1.44945 4.33193 1.93606 3.70971 2.47887 3.14273C3.605 1.97091 5.145 0.909091 7 0.909091C8.855 0.909091 10.3941 1.97091 11.522 3.14273C12.0648 3.70971 12.5514 4.33193 12.9745 5C12.9237 5.07909 12.8678 5.16636 12.8039 5.26182C12.5108 5.69818 12.0776 6.28 11.522 6.85727C10.3941 8.02909 8.85413 9.09091 7 9.09091C5.145 9.09091 3.60588 8.02909 2.478 6.85727C1.93519 6.29028 1.44946 5.66807 1.02637 5Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7 2.72721C6.41984 2.72721 5.86344 2.96665 5.4532 3.39287C5.04297 3.81909 4.8125 4.39717 4.8125 4.99993C4.8125 5.6027 5.04297 6.18078 5.4532 6.60699C5.86344 7.03321 6.41984 7.27266 7 7.27266C7.58016 7.27266 8.13656 7.03321 8.5468 6.60699C8.95703 6.18078 9.1875 5.6027 9.1875 4.99993C9.1875 4.39717 8.95703 3.81909 8.5468 3.39287C8.13656 2.96665 7.58016 2.72721 7 2.72721ZM3.9375 4.99993C3.9375 4.15606 4.26016 3.34676 4.83449 2.75005C5.40882 2.15334 6.18777 1.81812 7 1.81812C7.81223 1.81812 8.59118 2.15334 9.16551 2.75005C9.73984 3.34676 10.0625 4.15606 10.0625 4.99993C10.0625 5.8438 9.73984 6.65311 9.16551 7.24982C8.59118 7.84652 7.81223 8.18175 7 8.18175C6.18777 8.18175 5.40882 7.84652 4.83449 7.24982C4.26016 6.65311 3.9375 5.8438 3.9375 4.99993Z" })
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.8798 1.19201C11.9563 1.26957 11.9993 1.37462 11.9993 1.48414C11.9993 1.59365 11.9563 1.6987 11.8798 1.77627L11.0253 2.64024L9.3868 0.98512L10.2413 0.121149C10.3181 0.0435774 10.4223 0 10.5309 0C10.6395 0 10.7437 0.0435774 10.8205 0.121149L11.8798 1.19118V1.19201ZM10.4461 3.22449L8.8076 1.56938L3.22607 7.20836C3.18098 7.2539 3.14704 7.30944 3.12694 7.37056L2.46745 9.36829C2.45549 9.40471 2.45379 9.44377 2.46254 9.48111C2.4713 9.51844 2.49016 9.55259 2.51702 9.57972C2.54388 9.60685 2.57768 9.62591 2.61464 9.63475C2.65161 9.64359 2.69028 9.64188 2.72633 9.62979L4.70399 8.96361C4.76442 8.94355 4.8194 8.90955 4.86456 8.8643L10.4461 3.22532V3.22449Z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0 10.7585C0 11.0878 0.12947 11.4035 0.359928 11.6363C0.590385 11.8691 0.902953 11.9999 1.22887 11.9999H10.2406C10.5665 11.9999 10.8791 11.8691 11.1095 11.6363C11.34 11.4035 11.4694 11.0878 11.4694 10.7585V5.79319C11.4694 5.68345 11.4263 5.5782 11.3495 5.50061C11.2727 5.42301 11.1685 5.37941 11.0598 5.37941C10.9512 5.37941 10.847 5.42301 10.7702 5.50061C10.6934 5.5782 10.6502 5.68345 10.6502 5.79319V10.7585C10.6502 10.8683 10.607 10.9735 10.5302 11.0511C10.4534 11.1287 10.3492 11.1723 10.2406 11.1723H1.22887C1.12023 11.1723 1.01604 11.1287 0.939222 11.0511C0.862403 10.9735 0.819246 10.8683 0.819246 10.7585V1.6554C0.819246 1.54566 0.862403 1.44041 0.939222 1.36281C1.01604 1.28522 1.12023 1.24162 1.22887 1.24162H6.55397C6.66261 1.24162 6.7668 1.19803 6.84362 1.12043C6.92044 1.04283 6.96359 0.937583 6.96359 0.827842C6.96359 0.718101 6.92044 0.612854 6.84362 0.535256C6.7668 0.457657 6.66261 0.414063 6.55397 0.414062H1.22887C0.902953 0.414063 0.590385 0.544846 0.359928 0.777642C0.12947 1.01044 0 1.32618 0 1.6554V10.7585Z"
  })
], -1)
const _hoisted_39 = { class: "pagination-table-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_menu = _resolveComponent("company-menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_company_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: "/company/post-job-ad",
                  class: "primry-btn-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Create Advertisement")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search_job_title) = $event)),
                        placeholder: "Search by job title"
                      }, null, 512), [
                        [_vModelText, _ctx.search_job_title]
                      ])
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "primry-btn-1",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchByTitle && _ctx.searchByTitle(...args)), ["prevent"]))
                  }, "Search")
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_Calendar, {
                        modelValue: _ctx.JobsDate,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.JobsDate) = $event)),
                        dateFormat: "dd/mm/yy",
                        onDateSelect: _ctx.searchByDate,
                        placeholder: "Search by date"
                      }, null, 8, ["modelValue", "onDateSelect"])
                    ])
                  ])
                ])
              ]),
              (_ctx.showAlert)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Enter Job Title to Search "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("table", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("tbody", null, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                      _createElementVNode("td", _hoisted_22, [
                        _createVNode(_component_ProgressSpinner)
                      ])
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.jobAds, (ad) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: ad.id
                      }, [
                        _createElementVNode("td", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("h5", null, _toDisplayString(ad.title), 1),
                            _createElementVNode("p", null, [
                              _hoisted_25,
                              _hoisted_26,
                              _createTextVNode(" " + _toDisplayString((ad.ends_at) ? ad.ends_at : 'No Deadline'), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("h5", null, _toDisplayString(ad.job.job_title), 1),
                            _createElementVNode("p", _hoisted_29, [
                              _hoisted_30,
                              _hoisted_31,
                              _createTextVNode(" " + _toDisplayString((ad.ends_at) ? ad.ends_at : 'No Deadline'), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("span", _hoisted_33, _toDisplayString(ad.job.applications.length), 1)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["total-number", {'deep-pink': ad.status == 0}])
                          }, _toDisplayString(ad.status == 1 ? 'Live' : 'Inactive'), 3)
                        ]),
                        _createElementVNode("td", _hoisted_35, [
                          _createElementVNode("ul", _hoisted_36, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, {
                                to: _ctx.getJobDetail(ad.job_key, ad.job_slug)
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, {
                                to: '/company/post-job-ad?ad_id='+ad.id
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_38
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_Paginator, {
                first: _ctx.currentPage,
                "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPage) = $event)),
                rows: _ctx.rowsPerPage,
                totalRecords: _ctx.totalPages,
                onPage: _ctx.handlePageChange
              }, null, 8, ["first", "rows", "totalRecords", "onPage"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "switch-container"
              }, [
                _createElementVNode("p", null, _toDisplayString(item.label), 1),
                _createVNode(_component_InputSwitch, {
                  modelValue: item.value,
                  "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                  onClick: ($event: any) => (_ctx.toggleSwitch(index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}